module.exports = __webpack_public_path__ + "img/5.00fc6ad0.png";